import { render, staticRenderFns } from "./portfolioCompanies.vue?vue&type=template&id=108b7152&scoped=true"
import script from "./portfolioCompanies.vue?vue&type=script&lang=js"
export * from "./portfolioCompanies.vue?vue&type=script&lang=js"
import style0 from "./portfolioCompanies.vue?vue&type=style&index=0&id=108b7152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b7152",
  null
  
)

export default component.exports